import {
  MultiTypeBlock1,
  CheckboxBlocks,
  SubmitAndClear,
  MultiTypeBlock2,
  MultiTypeBlock3,
  MultiCheckboxBlocks,
  ZoneCheckboxes,
} from "./FilterBlocks";

import { useState } from 'react';
import staticData from "../data/form.json";

// const sheet = {
//   discipline: {
//     headers: [
//       "Type",
//       "Total#",
//       "Total%",
//       "Strike#",
//       "Strike%",
//       "Zone#",
//       "Zone%",
//       "Swing#",
//       "Swing%",
//       "好球揮棒率",
//       "Z-Swing%",
//       "O-Swing%",
//       "Contact#",
//       "Contact%",
//       "Z-Contact%",
//       "O-Contact%",
//       "Whiff#",
//       "Whiff%",
//       "Swtr%",
//       "In-Play#",
//       "In-Play%",
//     ],
//     data: [
//       {
//         title: "",
//         data: [
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//         ],
//       },
//     ],
//   },
//   score: {
//     headers: [
//       "Type",
//       "Avg",
//       "Avg L",
//       "Avg R",
//       "OBP",
//       "SLG",
//       "OPS",
//       "BABIP",
//       "K%",
//       "BB%",
//       "G",
//       "PA",
//       "AB",
//       "H",
//       "XBH",
//       "HR",
//       "TB",
//       "K",
//       "BB",
//     ],
//     data: [
//       {
//         title: "",
//         data: [
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//         ],
//       },
//       //{title: "直球", data:[0.233, 0.222, 0.267, 0.442, 0.452, 0.894, 0.288, '10%', '5%', 12, 109, 90, 22, 7, 1, 17, 11, 6]}
//     ],
//   },
//   hit: {
//     headers: [
//       "Type",
//       "GB%",
//       "LD%",
//       "FB%",
//       "IFFB%",
//       "HardHit%",
//       "SweetSpot%",
//       "Weak%",
//       "Topped%",
//       "Under%",
//       "Flare/Burner",
//       "Solid%",
//       "Barrel%",
//       "Soft%",
//       "Med%",
//       "Hard%",
//       "Pull%",
//       "Straight%",
//       "Oppo%",
//     ],
//     data: [
//       {
//         title: "",
//         data: [
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//         ],
//       },
//       //{title: "滑球", data:['20%', "50%", "60%", "15%", "20%", "30%", "10%", "15%", "60%", "15%", "20%", "30%", "10%", "15%", "10%", '10%', '10%']}
//     ],
//   },
// };

const LeftSidebar = ({ acmap }) => {
  const [searchType, setSearchType] = useState(0);

  return (
    <div className="filmroom_menu">
      <div className="filmroom_menu_block">
        <div className="filmroom_menu_col1">
          <div className={`btn_filmroom btn_${!searchType ? 'blue' : 'white'}_filmroom2`} onClick={() => setSearchType(0)}>逐球</div>
          <div className={`btn_filmroom btn_${searchType ? 'blue' : 'white'}_filmroom2`} onClick={() => setSearchType(1)}>逐打席</div>
        </div>
        <div className="filmroom_line_blue"></div>
        <MultiTypeBlock1 acmap={acmap} contents={staticData.menu.row1} />
        { !searchType && <MultiCheckboxBlocks rule={staticData.rule.row2} content={staticData.menu.row2} />}
        <MultiCheckboxBlocks rule={staticData.rule.row3} content={staticData.menu.row3} />
        <MultiCheckboxBlocks rule={staticData.rule.row4} content={staticData.menu.row4} />
        <CheckboxBlocks content={staticData.menu.row5} />
        { !searchType && <MultiCheckboxBlocks rule={staticData.rule.row6} content={staticData.menu.row6} /> }
        <MultiTypeBlock2 />
        { !searchType && <ZoneCheckboxes /> }
        { !searchType && <MultiTypeBlock3 content={staticData.ptypes} /> }
      </div>
      <SubmitAndClear clearField={staticData.defaultField} />
    </div>
  );
};

export default LeftSidebar;
